import React from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';

/**
 * WizardStepper Component
 * Shows progress through wizard steps with visual indicators
 */
export function WizardStepper({ steps, currentStep }) {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-8 py-6 border-b border-gray-200">
      <nav aria-label="Progress">
        <ol className="flex items-center justify-between">
          {steps.map((step, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < currentStep;
            const isCurrent = stepNumber === currentStep;
            const isPending = stepNumber > currentStep;

            return (
              <li
                key={step.id}
                className={`relative ${
                  index !== steps.length - 1 ? 'pr-8 sm:pr-20 flex-1' : ''
                }`}
              >
                {/* Connector Line */}
                {index !== steps.length - 1 && (
                  <div
                    className="absolute top-5 left-0 -ml-px mt-0.5 h-0.5 w-full"
                    aria-hidden="true"
                  >
                    <div
                      className={`h-full transition-all duration-500 ${
                        isCompleted
                          ? 'bg-blue-600'
                          : 'bg-gray-300'
                      }`}
                    />
                  </div>
                )}

                {/* Step Content */}
                <div className="relative flex flex-col items-start group">
                  <div className="flex items-center">
                    {/* Step Circle */}
                    <div
                      className={`flex h-10 w-10 items-center justify-center rounded-full border-2 transition-all duration-300 ${
                        isCompleted
                          ? 'bg-blue-600 border-blue-600'
                          : isCurrent
                          ? 'bg-white border-blue-600 ring-4 ring-blue-100'
                          : 'bg-white border-gray-300'
                      }`}
                    >
                      {isCompleted ? (
                        <CheckIcon
                          className="h-5 w-5 text-white"
                          aria-hidden="true"
                        />
                      ) : (
                        <span
                          className={`text-sm font-bold ${
                            isCurrent
                              ? 'text-blue-600'
                              : 'text-gray-400'
                          }`}
                        >
                          {stepNumber}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Step Text */}
                  <div className="mt-3">
                    <span
                      className={`block text-sm font-bold transition-colors ${
                        isCurrent
                          ? 'text-blue-600'
                          : isCompleted
                          ? 'text-gray-900'
                          : 'text-gray-500'
                      }`}
                    >
                      {step.name}
                    </span>
                    <span className="block text-xs text-gray-500 mt-0.5">
                      {step.description}
                    </span>
                  </div>
                </div>
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
}
